import React from 'react';
import { AppContext } from './Context';

class AppContextProvider extends React.Component {
  componentDidMount() {}

  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    const {
      locale,
      history,
      store,
      getComponent
    } = this.props;
    return /*#__PURE__*/React.createElement(AppContext.Provider, {
      value: {
        store,
        history,
        getComponent,
        locale,
        test: "testParam"
      }
    }, this.props.children);
  }

}

export default AppContextProvider;